import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import {
  authUser as authUserApi,
  loginUser as loginUserApi,
  logoutUser as logoutUserApi,
} from '../api/user'
import { AuthUser, LoginData, User } from '../types/users'

//auth user
export const authUser = createAsyncThunk('auth/auth', async (_, thunkApi) => {
  try {
    return await authUserApi()
  } catch (e) {
    return thunkApi.rejectWithValue('step Error')
  }
})

// user login
export const loginUser = createAsyncThunk(
  'auth/login',
  async (loginData: LoginData, thunkApi) => {
    try {
      return await loginUserApi(loginData)
    } catch (e) {
      return thunkApi.rejectWithValue('step Error')
    }
  },
)

export const logoutUser = createAsyncThunk(
  'auth/logout',
  async (_, thunkApi) => {
    try {
      return await logoutUserApi()
    } catch (e) {
      return thunkApi.rejectWithValue('step Error')
    }
  },
)

interface authSliceState {
  user?: AuthUser
  isAuthLoading: boolean
  isAuthError?: SerializedError
  isLoginFail: boolean
  loginLoading: boolean
  loginError?: SerializedError
}

const initialState: authSliceState = {
  user: undefined,
  isAuthLoading: true,
  isAuthError: undefined,
  isLoginFail: false,
  loginLoading: false,
  loginError: undefined,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsLoginFail: (state, action: PayloadAction<boolean>) => {
      state.isLoginFail = action.payload
    },
    setAuthUser: (state, action: PayloadAction<AuthUser | undefined>) => {
      state.user = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authUser.fulfilled, (
      state,
      action: PayloadAction<AuthUser | undefined>,
    ) => {
      state.user = action.payload
      state.isAuthLoading = false
      state.isAuthError = undefined
    })
    builder.addCase(authUser.pending, (state) => {
      state.isAuthLoading = true
      state.isAuthError = undefined
    })
    builder.addCase(authUser.rejected, (state, action) => {
      state.isAuthLoading = false
      state.isAuthError = action.error
    })
    builder.addCase(loginUser.fulfilled, (
      state,
      action: PayloadAction<AuthUser | undefined>,
    ) => {
      state.user = action.payload
      state.isLoginFail = !action.payload
      state.loginLoading = false
      state.loginError = undefined
    })
    builder.addCase(loginUser.pending, (state) => {
      state.loginLoading = true
      state.loginError = undefined
    })
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loginLoading = false
      state.loginError = action.error
    })
    builder.addCase(logoutUser.fulfilled, (state) => {
      state.user = undefined
      state.isAuthLoading = false
      state.isAuthError = undefined
      state.isLoginFail = false
      state.loginLoading = false
      state.loginError = undefined
    })
  },
})

export const { setIsLoginFail, setAuthUser } = authSlice.actions
export default authSlice.reducer
